export enum RugbyUnionConversionGoalAttribute {
  Golden = 1064,
}
